/**
 * Ski Groups Service
 * Handles all ski group-related API calls
 */
import { getIdToken } from '../contexts/AuthContext';
import { buildApiUrl, getAuthHeaders } from '../config/api';

/**
 * Get ski group details by ID
 * @param {string} skiGroupId - Ski group ID
 * @param {Function} addError - Error handler function (optional)
 * @returns {Promise<Object>} Ski group details with buddies
 */
export const getSkiGroupDetails = async (skiGroupId, addError = null) => {
  try {
    const idToken = await getIdToken();
    if (!idToken) {
      throw new Error('Not authenticated. Please log in.');
    }

    const response = await fetch(buildApiUrl(`/skigroups/${skiGroupId}`), {
      headers: getAuthHeaders(idToken)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: response.statusText }));
      throw new Error(errorData.message || errorData.error || `Failed to fetch ski group details: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    const errorMsg = error.message || 'Error fetching ski group details';
    if (addError) addError(errorMsg, error.stack, 'Ski Groups API');
    console.error('Error fetching ski group details:', error);
    throw error;
  }
};
